import { forwardRef, type Ref, type SVGProps } from "react";
const IconShareWebFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17.414 2.586a2 2 0 0 0-2.828 0l-6 6a2 2 0 1 0 2.828 2.828L14 8.828V22a2 2 0 1 0 4 0V8.828l2.586 2.586a2 2 0 1 0 2.828-2.828z" />
    <path d="M4 14a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2h-4a2 2 0 1 0 0 4h2v8H6v-8h2a2 2 0 1 0 0-4z" />
  </svg>
);
const ForwardRef = forwardRef(IconShareWebFilledSVG);
ForwardRef.displayName = "IconShareWebFilled";
export { ForwardRef as IconShareWebFilled };
